import React, { useState, useEffect } from 'react'
import axios from 'axios'
import ReactDOMServer from 'react-dom/server'
import html2pdf from 'html2pdf.js'

import './NovoProcesso.css'
import brasao from '../../assets/brasilNav.png'
import Portaria from './Portaria'
import CapaProcesso from './CapaProcesso'

const NovoProcesso = () => {
    const [formData, setFormData] = useState({
        responsavel: "",
        portaria: "",
        dataInstauracao: "",
        tipo: "",
        considerandoQue: [],
        motivo: "",
        interessados: []
    })

    const [users, setUsers] = useState([])
    const [quantidadeInteressados, setQuantidadeInteressados] = useState(0)

    const updateField = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }))
    }

    const updateConsiderando = (index, value) => {
        const novosConsiderandos = [...formData.considerandoQue]
        novosConsiderandos[index] = value
        setFormData(prev => ({
            ...prev,
            considerandoQue: novosConsiderandos
        }))
    }

    const handleQuantidadeConsiderandosChange = (e) => {
        const quantidade = Math.max(0, parseInt(e.target.value) || 0)
        const novosConsiderandos = Array.from({ length: quantidade }, (_, i) => formData.considerandoQue[i] || "")
        setFormData(prev => ({
            ...prev,
            considerandoQue: novosConsiderandos
        }))
    }

    const updateInteressado = (index, field, value) => {
        const updatedInteressados = [...formData.interessados]
        updatedInteressados[index] = {
            ...updatedInteressados[index],
            [field]: value
        }
        setFormData(prev => ({
            ...prev,
            interessados: updatedInteressados
        }))
    }

    const handleQuantidadeChange = (e) => {
        const quantidade = Math.max(0, parseInt(e.target.value) || 0)
        setQuantidadeInteressados(quantidade)
        const novosInteressados = Array.from({ length: quantidade }, (_, i) => formData.interessados[i] || { tipo: "fisica" })
        setFormData(prev => ({ ...prev, interessados: novosInteressados }))
    }

    const gerarPDF = async (idProcesso, message, numeroProcesso) => {
        try {
            // Renderiza os componentes `Portaria` e `CapaProcesso` como HTML
            const portariaHTML = ReactDOMServer.renderToString(<Portaria processo={formData} />)
            const capaProcessoHTML = ReactDOMServer.renderToString(<CapaProcesso processo={formData} numero={numeroProcesso} />)

            // Cria contêineres temporários para os HTMLs renderizados
            const tempElementPortaria = document.createElement('div')
            tempElementPortaria.innerHTML = portariaHTML
            document.body.appendChild(tempElementPortaria)

            const tempElementCapa = document.createElement('div')
            tempElementCapa.innerHTML = capaProcessoHTML
            document.body.appendChild(tempElementCapa)

            // Configurações do PDF
            const options = {
                margin: [10, 10, 10, 10],
                image: { type: 'jpeg', quality: 0.8 },
                html2canvas: { scale: 2, useCORS: true, allowTaint: false },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            }

            // Gera os PDFs como objetos Blob
            const pdfBlobPortaria = await new Promise((resolve, reject) => {
                html2pdf()
                    .set(options)
                    .from(tempElementPortaria)
                    .toPdf()
                    .outputPdf('blob')
                    .then(resolve)
                    .catch(reject)
            })

            const pdfBlobCapa = await new Promise((resolve, reject) => {
                html2pdf()
                    .set(options)
                    .from(tempElementCapa)
                    .toPdf()
                    .outputPdf('blob')
                    .then(resolve)
                    .catch(reject)
            })

            // Remove os contêineres temporários do DOM
            document.body.removeChild(tempElementPortaria)
            document.body.removeChild(tempElementCapa)

            // Constrói o FormData para enviar ao backend
            const url = `/api/anexos/postsJuridico`
            const newFormDataCapa = new FormData()
            newFormDataCapa.append('file', pdfBlobCapa, `capa_processo_${idProcesso}.pdf`)
            newFormDataCapa.append('idProcesso', idProcesso)
            newFormDataCapa.append('user', localStorage.nomeJ || '')
            newFormDataCapa.append('nomeArquivo', `Capa do Processo`)
            newFormDataCapa.append('tipoAnexo', 'Capa do Processo')
            newFormDataCapa.append('dataCriacao', new Date().toLocaleString())

            const newFormDataPortaria = new FormData()
            newFormDataPortaria.append('file', pdfBlobPortaria, `portaria_${idProcesso}.pdf`)
            newFormDataPortaria.append('idProcesso', idProcesso)
            newFormDataPortaria.append('user', localStorage.nomeJ || '')
            newFormDataPortaria.append('nomeArquivo', `Portaria ${formData.portaria}`)
            newFormDataPortaria.append('tipoAnexo', 'Portaria')
            newFormDataPortaria.append('dataCriacao', new Date().toLocaleString())


            // Envia ambos os PDFs via Axios
            await axios.post(url, newFormDataCapa, { headers: { 'Content-Type': 'multipart/form-data' } })
            await axios.post(url, newFormDataPortaria, { headers: { 'Content-Type': 'multipart/form-data' } })

            alert(message)
            window.location = `/juridico/processo/${idProcesso}`
        } catch (error) {
            console.error('Erro ao gerar ou enviar os PDFs:', error)
            alert('Erro ao gerar ou enviar os PDFs. Contate o suporte.')
        }
    }

    const save = () => {
        axios.post('/api/juridico/novoProcesso', formData)
            .then(res => {
                const idProcesso = res.data.id
                const numeroProcesso = res.data.numeroProcesso
                gerarPDF(idProcesso, res.data.message, numeroProcesso) // Gera o PDF e envia ao backend
            })
            .catch(error => {
                console.log(error)
                alert(error.response.data.message)
            })
    }

    useEffect(() => {
        axios('/api/userJuridico/getAdvogados')
            .then(res => setUsers(res.data))
            .catch(error => alert(error.response.message))
    }, [])

    const aplicarMascaraCNPJ = (valor) => {
        return valor
            .replace(/\D/g, '')
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1/$2')
            .replace(/(\d{4})(\d)/, '$1-$2')
            .substring(0, 18)
    }

    const aplicarMascaraTelefone = (valor) => {
        return valor
            .replace(/\D/g, '')
            .replace(/^(\d{2})(\d)/g, '($1) $2')
            .replace(/(\d{5})(\d)/, '$1-$2')
            .substring(0, 15)
    }

    const aplicarMascaraCNES = (valor) => {
        return valor
            .replace(/\D/g, '')
            .substring(0, 7)
    }

    return (
        <>
            <div className="containerJuridico">
                <div className="headerJuridico">
                    <img src={brasao} alt="Brasil" />
                    <h1>Cadastro de Processo</h1>
                </div>
                <div className="fieldGroupJuridico">
                    <label>Responsável</label>
                    <select
                        onChange={e => updateField('responsavel', e.target.value)}
                        value={formData.responsavel}>
                        <option value="" disabled>Selecione...</option>
                        {users.map(user => (
                            <option key={user._id} value={user._id}>{user.nome}</option>
                        ))}
                    </select>
                </div>
                <div className="fieldGroupJuridico">
                    <label>Portaria que instaurou o PAD</label>
                    <input
                        type="text"
                        onChange={e => updateField('portaria', e.target.value)}
                        value={formData.portaria} />
                </div>
                <div className="fieldGroupJuridico">
                    <label>Data de Instauração</label>
                    <input
                        type="date"
                        onChange={e => updateField('dataInstauracao', e.target.value)}
                        value={formData.dataInstauracao} />
                </div>
                <div className="fieldGroupJuridico">
                    <label>Classificação</label>
                    <select
                        onChange={e => updateField('tipo', e.target.value)}
                        value={formData.tipo}>
                        <option value="" disabled>Selecione...</option>
                        <option value="Violação de Prerrogativas">Violação de Prerrogativas</option>
                        <option value="Cobrança">Cobrança</option>
                        <option value="Inscrição Profissional">Inscrição Profissional</option>
                        <option value="Registro de Empresas">Registro de Empresas</option>
                        <option value="Arrecadação">Arrecadação</option>
                        <option value="Licitação e contratos">Licitação e contratos</option>
                        <option value="Outros">Outros</option>
                    </select>
                </div>
                <div className="fieldGroupJuridico">
                    <label>Instaurar procedimento para:</label>
                    <textarea
                        onChange={e => updateField('motivo', e.target.value)}
                        value={formData.motivo}></textarea>
                </div>
                <div className="fieldGroupJuridico">
                    <label>Quantidade de "Considerando que:"</label>
                    <input
                        type="number"
                        min="0"
                        value={formData.considerandoQue.length}
                        onChange={handleQuantidadeConsiderandosChange}
                    />
                </div>
                {formData.considerandoQue.map((considerando, index) => (
                    <div key={index} className="fieldGroupJuridico">
                        <label>Considerando que {index + 1}:</label>
                        <textarea
                            value={considerando}
                            onChange={e => updateConsiderando(index, e.target.value)}
                        />
                    </div>
                ))}
                <div className="fieldGroupJuridico">
                    <label>Quantidade de Interessados</label>
                    <input
                        type="number"
                        min="0"
                        value={quantidadeInteressados}
                        onChange={handleQuantidadeChange} />
                </div>
                {formData.interessados.map((interessado, index) => (
                    <div key={index} className="fieldGroupJuridico">
                        <label>Interessado {index + 1}</label>
                        <select
                            value={interessado.tipo}
                            onChange={e => updateInteressado(index, 'tipo', e.target.value)}>
                            <option value="fisica">Pessoa Física</option>
                            <option value="juridica">Pessoa Jurídica</option>
                        </select>
                        {interessado.tipo === "fisica" ? (
                            <>
                                <input
                                    placeholder="Nome completo"
                                    value={interessado.nome || ""}
                                    onChange={e => updateInteressado(index, 'nome', e.target.value)} />
                                <input
                                    placeholder="Profissão"
                                    value={interessado.profissao || ""}
                                    onChange={e => updateInteressado(index, 'profissao', e.target.value)} />
                                <input
                                    placeholder="CREFITO"
                                    value={interessado.crefito || ""}
                                    onChange={e => updateInteressado(index, 'crefito', e.target.value)} />
                            </>
                        ) : (
                            <>
                                <input
                                    placeholder="Razão Social"
                                    value={interessado.razaoSocial || ""}
                                    onChange={e => updateInteressado(index, 'razaoSocial', e.target.value)} />
                                <input
                                    placeholder="Natureza Jurídica"
                                    value={interessado.naturezaJuridica || ""}
                                    onChange={e => updateInteressado(index, 'naturezaJuridica', e.target.value)} />
                                <input
                                    placeholder="CNPJ"
                                    value={aplicarMascaraCNPJ(interessado.cnpj || "")}
                                    onChange={e => updateInteressado(index, 'cnpj', e.target.value)} />
                                <input
                                    placeholder="CNES"
                                    value={aplicarMascaraCNES(interessado.cnes || "")}
                                    onChange={e => updateInteressado(index, 'cnes', e.target.value)} />
                            </>
                        )}
                        <input
                            placeholder="Endereço Completo"
                            value={interessado.endereco || ""}
                            onChange={e => updateInteressado(index, 'endereco', e.target.value)} />
                        <input
                            placeholder="Telefone"
                            value={aplicarMascaraTelefone(interessado.telefone || "")}
                            onChange={e => updateInteressado(index, 'telefone', e.target.value)} />
                        <input
                            placeholder="E-mail"
                            value={interessado.email || ""}
                            onChange={e => updateInteressado(index, 'email', e.target.value)} />
                    </div>
                ))}
                <button className="buttonJuridico" onClick={save}>Salvar</button>
            </div>
        </>
    )
}

export default NovoProcesso
